import React, { type JSX } from "react";
import { getClassName } from "@sscs/utils";
import styles from "./label.module.scss";

type LabelProps = {
  label: string;
  isDisabled?: boolean;
  isOptional?: boolean;
};

const Label = ({
  label,
  isDisabled = false,
  isOptional = false,
}: LabelProps): JSX.Element => {
  return (
    <p
      className={getClassName(styles["field-label"], {
        [styles["field-label-disabled"]]: isDisabled,
      })}
    >
      {label}
      {isOptional && (
        <span className={styles["field-label-optional"]}>(Optional)</span>
      )}
    </p>
  );
};

export default Label;
